import React, { useState, useEffect } from 'react';
import { Download, X, Smartphone } from 'lucide-react';

export default function InstallBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Check if already installed or running in native app
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (window.Capacitor?.isNativePlatform()) return;

    // Check if dismissed recently
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed && Date.now() - parseInt(dismissed) < 7 * 24 * 60 * 60 * 1000) return;

    // iOS detection
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);

    // Android/Chrome: listen for beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Show banner after 3 seconds on any mobile device
    const isMobile = /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
    if (isMobile) {
      const timer = setTimeout(() => setShowBanner(true), 3000);
      return () => { clearTimeout(timer); window.removeEventListener('beforeinstallprompt', handler); };
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const result = await deferredPrompt.userChoice;
      if (result.outcome === 'accepted') {
        setShowBanner(false);
      }
      setDeferredPrompt(null);
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 99999,
      background: '#1A2332', borderTop: '2px solid #C8A45C',
      padding: '0.85rem 1.25rem', boxShadow: '0 -4px 20px rgba(0,0,0,0.4)',
    }} data-testid="install-banner">
      <div style={{
        maxWidth: 800, margin: '0 auto', display: 'flex', alignItems: 'center', gap: '0.75rem',
      }}>
        <Smartphone size={28} style={{ color: '#C8A45C', flexShrink: 0 }} />
        <div style={{ flex: 1 }}>
          <strong style={{ color: '#FFFFFF', fontSize: '1rem', display: 'block' }}>Freiheitsmacher App</strong>
          {isIOS ? (
            <span style={{ color: '#B8C4D0', fontSize: '0.82rem' }}>Tippe auf <strong style={{ color: '#C8A45C' }}>Teilen</strong> → <strong style={{ color: '#C8A45C' }}>Zum Home-Bildschirm</strong></span>
          ) : (
            <span style={{ color: '#B8C4D0', fontSize: '0.82rem' }}>Installiere die App für schnellen Zugriff</span>
          )}
        </div>
        {!isIOS && (
          <button onClick={handleInstall} data-testid="install-btn" style={{
            display: 'flex', alignItems: 'center', gap: '0.4rem',
            padding: '0.6rem 1.2rem', background: 'linear-gradient(135deg, #C8A45C, #E8D4A0)',
            color: '#1A2332', border: 'none', borderRadius: '8px', fontWeight: 700,
            fontSize: '0.88rem', cursor: 'pointer', whiteSpace: 'nowrap',
          }}>
            <Download size={16} /> Installieren
          </button>
        )}
        <button onClick={handleDismiss} data-testid="install-dismiss" style={{
          background: 'none', border: 'none', color: '#8A9AAC', cursor: 'pointer', padding: '6px', flexShrink: 0,
        }}>
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
